<template>
    <div>
        <Modal
            v-model="show"
            :width="1300"
            draggable
            :footer-hide="true"
            title="定单明细"
        >
            <div
                style="max-height: 620px; overflow-y: auto; overflow-x: hidden"
                class="add-wrap"
            >
                <Card
                    :padding="0"
                    :bordered="false"
                    :dis-hover="true"
                    style="position: relative; padding-bottom: 80px"
                >
                    <div class="global-tool-bar" style="padding-top: 16px">
                        <div class="left-bar"></div>
                        <div class="right-bar">
                            <Poptip
                                confirm
                                placement="bottom-end"
                                title="请确认新增定单信息是否无误？"
                                @on-ok="addToPreSaleCart"
                                @on-cancel="cancel"
                                style="text-align: left"
                            >
                                <Button type="primary">保存</Button>
                            </Poptip>
                        </div>
                    </div>
                    <Row :gutter="24">
                        <Col span="24">
                            <Form
                                label-position="top"
                                class="form-input-no-outline"
                            >
                                <Row :gutter="24">
                                    <Col span="6">
                                        <FormItem label="苗场">
                                            <Select
                                                v-model="
                                                    preSaleOrderRecordVO.seedFarmUuid
                                                "
                                                filterable
                                                clearable
                                                placeholder="请选择苗场"
                                                :disabled="$checkAccessArray(['B'])"
                                                @on-change="onSeedFarmChange"
                                            >
                                                <Option
                                                    v-for="item in seedFarmList"
                                                    :key="item.seedFarmUuid"
                                                    :value="item.seedFarmUuid"
                                                >{{ item.seedFarmCode }}-{{ item.seedFarmName }}
                                                </Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span="6">
                                        <FormItem label="周次">
                                            <Select
                                                v-model="
                                                    preSaleOrderRecordVO.selectedWeek
                                                "
                                                placeholder="选择周次"
                                                :disabled="!chooseProductUuid"
                                                @on-change="onWeekSelectChange"
                                            >
                                                <Option
                                                    v-for="week in filterModel.weekList"
                                                    :key="week.weekKnownText"
                                                    :value="week.weekKnownText"
                                                >
                                                    {{ week.weekKnownTextCh }}({{ week.weekBeginDate }}~{{ week.weekEndDate }})
                                                </Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span="6">
                                        <FormItem label="发货时间">
                                            <Select
                                                v-model="
                                                    preSaleOrderRecordVO.selectDay
                                                "
                                                placeholder="选择发货日期"
                                                :disabled="!chooseProductUuid"
                                            >
                                                <Option
                                                    v-for="day in filterModel.dayList"
                                                    :key="day"
                                                    :value="day"
                                                >{{ day }}</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span="4">
                                        <FormItem label="客户名称">
                                            <Input
                                                :value="
                                                    preSaleOrderRecordVO.userExternalCustomerName
                                                "
                                                disabled
                                            />
                                        </FormItem>
                                    </Col>
                                    <Col span="4">
                                        <FormItem label="联系方式">
                                            <Input
                                                :value="
                                                    preSaleOrderRecordVO.contactNumber
                                                "
                                                disabled
                                            />
                                        </FormItem>
                                    </Col>
                                    <Col span="4">
                                        <FormItem label="客户经理">
                                            <Input
                                                class="customerColor"
                                                :value="
                                                    preSaleOrderRecordVO.customerName
                                                "
                                                disabled
                                            />
                                        </FormItem>
                                    </Col>
                                </Row>

                                <!-- 新增客户地址和苗场备注 -->
                                <Row :gutter="24">
                                    <Col span="12">
                                        <FormItem label="收货地址">
                                            <Input
                                                :value="
                                                    preSaleOrderRecordVO.receiptFullAddress
                                                "
                                                disabled
                                            />
                                        </FormItem>
                                    </Col>
                                    <Col span="12">
                                        <FormItem label="苗场备注">
                                            <Input
                                                v-model="
                                                    preSaleOrderRecordVO.remark
                                                "
                                                type="textarea"
                                            />
                                        </FormItem>
                                    </Col>
                                </Row>

                                <Row :gutter="24">
                                    <Col span="24">
                                        <div
                                            style="
                                                width: 100%;
                                                text-align: right;
                                                padding-bottom: 10px;
                                            "
                                            v-if="
                                                $checkAccessArray([
                                                    'B',
                                                    'C',
                                                    'G',
                                                ])
                                            "
                                        >
                                            <Button
                                                type="success"
                                                @click="addNewProductRow"
                                                >新增产品</Button
                                            >
                                        </div>
                                        <FormItem>
                                            <Table
                                                border
                                                :columns="orderDetail.columns"
                                                :data="orderDetail.tableData"
                                            >
                                                <template
                                                    slot-scope="{ row, index }"
                                                    slot="index"
                                                >
                                                    {{ index + 1 }}
                                                </template>

                                                <template
                                                    slot-scope="{ row, index }"
                                                    slot="productUuid"
                                                >
                                                    <Select
                                                        v-model="row.productUuid"
                                                        placeholder="选择编码或品名"
                                                        filterable
                                                        @on-open-change="
                                                            (status) =>
                                                                handleOpenChange(
                                                                    status,
                                                                    index
                                                                )
                                                        "
                                                        @on-change="
                                                            (value) =>
                                                                onProductSelectChange(
                                                                    row,
                                                                    index
                                                                )
                                                        "
                                                        :key="row._rowId"
                                                        style="text-align: left"
                                                    >
                                                        <Option
                                                            v-for="item in orderDetail
                                                                .tableData[
                                                                index
                                                            ].filterProductList"
                                                            :key="item.productUuid"
                                                            :value="item.productUuid"
                                                        >{{ item.productCode }}-{{ item.productName }}
                                                        </Option>
                                                    </Select>
                                                </template>

                                                <template
                                                    slot-scope="{ row, index }"
                                                    slot="orderQuantity"
                                                >
                                                    <InputNumber
                                                        :min="0"
                                                        :active-change="false"
                                                        :max="
                                                            row.preSalePlanOfferAmount
                                                        "
                                                        :step="
                                                            row.productIncreaseStepAmount
                                                        "
                                                        :precision="
                                                            row.isRounded == 1
                                                                ? 0
                                                                : 2
                                                        "
                                                        v-model="
                                                            row.orderQuantity
                                                        "
                                                        @on-change="
                                                            (value) =>
                                                                saveCurRow(
                                                                    row,
                                                                    index
                                                                )
                                                        "
                                                        :key="row._rowId"
                                                    />
                                                </template>

                                                <template
                                                    slot-scope="{ row, index }"
                                                    slot="action"
                                                >
                                                    <div>
                                                        <Button
                                                            @click="
                                                                dels(row, index)
                                                            "
                                                            >删除</Button
                                                        >
                                                    </div>
                                                </template>
                                            </Table>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Card>

                <Card
                    style="
                        position: absolute;
                        right: 35px;
                        bottom: 0;
                        width: 96%;
                        z-index: 100002;
                    "
                >
                    <Row
                        :gutter="16"
                        style="
                            border: 1px solid #dddddd;
                            background-color: #f7f7f7;
                            padding: 10px;
                            border-radius: 3px;
                        "
                    >
                        <Col span="24">
                            <Form
                                label-position="top"
                                class="form-input-no-outline"
                            >
                                <div class="global-tool-bar">
                                    <div class="left-bar"></div>
                                    <div class="right-bar">
                                        <div>
                                            合计: &nbsp;&nbsp; 数量:
                                            <span class="red-color">{{
                                                totalMainCount
                                            }}</span>
                                            &nbsp;&nbsp;金额:
                                            <span class="red-color"
                                                >{{ totalMainMoney }}元</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </div>
        </Modal>
    </div>
</template>

<script>
import search from "@/libs/search";
import { formatDateTimeString, getWeek } from "@/libs/logic";
import {
    getUserInfoByUuid,
    getAllProductList,
    getPreSaleProductInfo,
    webSubmitToOrderBatch,
    savePreSaleOrderDetailSort,
    getSeedFarmDeliveryWeek
} from "@/api/modules/sale-management/sale-approve";
import { getPreSalePlanWeekList } from "@/api/modules/preSale-management/preSale-plan";
import { getSeedFarmAllList } from "@/api/modules/system-management/seedFarm-management.js";

// 错误消息常量
const ERROR_MESSAGES = {
    EMPTY_CUSTOMER: "非常抱歉，客户不能为空！",
    EMPTY_PRODUCT_INFO: "非常抱歉，产品信息不能为空！",
    EMPTY_WEEK: "非常抱歉，周次不能为空！",
    EMPTY_DELIVERY_DATE: "非常抱歉，发货日期不能为空！",
    EMPTY_CONTACT: "非常抱歉，联系方式不能为空！",
    EMPTY_ADDRESS: "非常抱歉，收货地址不能为空！",
    EMPTY_PRODUCT_CODE: "非常抱歉，编码品名不能为空！",
    EMPTY_QUANTITY: "非常抱歉，购买数量不能为空！",
    INVALID_QUANTITY: "非常抱歉，购买数量不能等于小于0！",
    EMPTY_PLAN_UUID: "非常抱歉，销售计划ID不能为空！",
    CONTACT_TOO_LONG: "非常抱歉，联系方式字符过长！",
    ADDRESS_TOO_LONG: "非常抱歉，收货地址字符过长！",
    REMARK_TOO_LONG: "非常抱歉，苗场备注字符过长！"
};

// 产品警告消息常量
const PRODUCT_WARNING_MESSAGES = {
    NO_SALES_PLAN: "非常抱歉，当前周次没有产品上传供货计划！",
    NO_PRODUCTS_FOUND: "当前年份周次查不到商品，请查询供货计划或者苗场认可关系"
};

export default {
    name: "AddPreSaleOrderRecord",
    components: {},
    data() {
        return {
            show: false,
            userUuid: "",
            chooseProductUuid: true,
            preSaleOrderRecordVO: {},
            pageLoading: false,
            productModel: {
                realUserUuid: "",
                productUuid: "",
                productPreSaleWarehouseAmount: null,
                productIncreaseStepAmount: 1,
                productMinOrderAmount: 1
            },
            filterModel: {
                yearList: [],
                weekList: [],
                dayList: [],
                curWeekPlans: [],
                loadWeekPlans: false,
                selectedYearWeekList: [],
                selectedYearPlans: [],
                selectedYearFilterPlans: [],
                monthList: [],
                selectedMonth: 0,
                selectedMonthShow: false,
                selectedMonthText: "",
                loadYearPlans: false,
                selectedYear: 0,
                selectedWeeks: [],
                tabList: [
                    {
                        name: "本周"
                    },
                    {
                        name: "按周"
                    },
                    {
                        name: "按年"
                    }
                ],
                swiperCurrent: 0
            },
            orderDetail: {
                columns: [
                    {
                        title: "序号",
                        align: "center",
                        width: 80,
                        slot: "index"
                    },
                    {
                        title: "产品信息",
                        align: "center",
                        width: 260,
                        slot: "productUuid"
                    },
                    {
                        title: "苗场",
                        align: "center",
                        key: "seedFarmName"
                    },
                    {
                        title: "产品形态",
                        align: "center",
                        key: "productForm"
                    },
                    {
                        title: "品牌",
                        align: "center",
                        key: "brandName"
                    },
                    {
                        title: "可售量",
                        align: "center",
                        key: "preSalePlanOfferAmount"
                    },
                    {
                        title: "单位",
                        align: "center",
                        key: "unitName"
                    },
                    {
                        title: "单价",
                        align: "center",
                        key: "preSalePlanPrice"
                    },
                    {
                        title: "数量",
                        align: "center",
                        width: 160,
                        slot: "orderQuantity"
                    },
                    {
                        title: "金额",
                        align: "center",
                        width: 160,
                        key: "totalMoney"
                    },
                    {
                        title: "操作",
                        slot: "action",
                        align: "center",
                        width: 160
                    }
                ],
                tableData: [],
                productList: []
            },
            seedFarmDeliveryWeek: "",
            seedFarmList: [],
            orderDetailCache: []
        };
    },
    computed: {
        /**
         * 计算总数量
         * @returns {number} 总数量
         */
        totalMainCount() {
            return this.orderDetail.tableData.reduce((total, item) => {
                return total + (item.orderQuantity || 0);
            }, 0);
        },

        /**
         * 计算总金额
         * @returns {number} 总金额
         */
        totalMainMoney() {
            const total = this.orderDetail.tableData.reduce((total, item) => {
                return total + (item.totalMoney || 0);
            }, 0);

            // 保留两位小数
            return Math.round(total * 100) / 100;
        }
    },
    mounted() {
        this.getSeedFarmDeliveryWeek();
    },
    methods: {
        saveCurRow(row, index) {
            // 更新当前行的数量
            this.orderDetail.tableData[index].orderQuantity = row.orderQuantity;

            // 计算当前行的金额
            const itemTotalMoney = this.calculateItemTotal(
                row.orderQuantity,
                this.orderDetail.tableData[index].preSalePlanPrice
            );
            this.orderDetail.tableData[index].totalMoney = itemTotalMoney;

            // 检查数量是否超过可售量
            this.checkQuantity(row, index);
        },
        moveRowUp(index) {
            if (index <= 0) return;
            const newData = [...this.orderDetail.tableData];
            const temp = newData[index - 1];
            newData[index - 1] = newData[index];
            newData[index] = temp;
            this.orderDetail.tableData = newData;
            this.updateOrderSort();
        },
        moveRowDown(index) {
            if (index >= this.orderDetail.tableData.length - 1) return;
            const newData = [...this.orderDetail.tableData];
            const temp = newData[index + 1];
            newData[index + 1] = newData[index];
            newData[index] = temp;
            this.orderDetail.tableData = newData;
            this.updateOrderSort();
        },
        updateOrderSort() {
            this.orderDetail.tableData.forEach((item, idx) => {
                this.$set(item, "orderSort", idx + 1);
            });
        },

        /**
         * 计算单项金额
         * @param {number} quantity - 数量
         * @param {number} price - 单价
         * @returns {number} 金额
         */
        calculateItemTotal(quantity, price) {
            // 保留三位小数的价格
            const planPrice = parseFloat(price.toFixed(3));

            // 使用整数计算，避免浮点误差
            const planTotalMoney = Math.round(quantity * planPrice * 100) / 100;

            // 保证保留两位小数
            return Math.round(planTotalMoney * 100) / 100;
        },

        onSeedFarmChange() {
            // 苗场变更处理（只有在模态框显示后才响应）
            if (this.show) {
                this.getWeekList();
            }
        },
        /**
         * 检查订购数量是否超过可售量
         * @param {Object} row - 表格行数据
         * @param {number} index - 表格行索引
         */
        checkQuantity(row, index) {
            const { orderQuantity, preSalePlanOfferAmount } = row;

            if (orderQuantity > preSalePlanOfferAmount) {
                this.$Message.error({
                    content: `数量不能大于可售量`,
                    duration: 5
                });

                // 自动调整为最大可售量
                this.$set(
                    this.orderDetail.tableData[index],
                    "orderQuantity",
                    preSalePlanOfferAmount
                );
            }
        },
        /**
         * 获取产品列表
         * @param {string|number} selectedYearAndWeek - 选定的年份和周次
         */
        async getProductList(selectedYearAndWeek) {
            const data = this.buildProductQueryData(selectedYearAndWeek);

            try {
                const res = await getAllProductList(data);

                if (res.code === 0) {
                    if (res.data.selectProductVOList.length > 0) {
                        this.orderDetail.productList = res.data.selectProductVOList;
                    }
                    else {
                        this.showProductWarning();
                    }
                }
            }
            catch (error) {
                console.error("获取产品列表失败:", error);
                this.$Message.error("获取产品列表失败，请稍后重试");
            }
        },

        /**
         * 构造产品查询数据
         * @param {string|number} selectedYearAndWeek - 选定的年份和周次
         * @returns {Object} 查询数据
         */
        buildProductQueryData(selectedYearAndWeek) {
            if (!selectedYearAndWeek) {
                return {};
            }

            const strYearAndWeek = String(selectedYearAndWeek);
            const strYear = strYearAndWeek.substring(0, 4);
            const strWeekSeq = strYearAndWeek.substring(4, 6);

            const queryData = { year: strYear, weekSeq: strWeekSeq };

            // 只有当选择了具体苗场时才传递 seedFarmUuid
            if (this.preSaleOrderRecordVO.seedFarmUuid) {
                queryData.seedFarmUuid = this.preSaleOrderRecordVO.seedFarmUuid;
            }

            return queryData;
        },

        /**
         * 显示产品警告信息
         */
        showProductWarning() {
            if (this.$checkAccessArray(["B", "C"])) {
                this.$Modal.warning({
                    title: PRODUCT_WARNING_MESSAGES.NO_SALES_PLAN,
                    content: ""
                });
            }
            else if (this.$checkAccessArray(["G"])) {
                this.$Modal.warning({
                    title: PRODUCT_WARNING_MESSAGES.NO_PRODUCTS_FOUND,
                    content: ""
                });
            }
        },
        /**
         * 删除表格行
         * @param {Object} row - 表格行数据
         * @param {number} index - 行索引
         */
        dels(row, index) {
            if (!row) return;

            const removeId = row._rowId;

            // 用 filter 生成新数组（改变数组引用，Vue 会正确 diff）
            this.orderDetail.tableData = this.orderDetail.tableData.filter(r => r._rowId !== removeId);

            // 为剩余行重建 filterProductList（避免引用共享导致的状态污染）
            this.orderDetail.tableData.forEach((r, i) => {
                this.$set(r, 'filterProductList', [...this.orderDetail.productList]);
                // 重新应用已选产品过滤
                this.removeSelectedProducts(i);
            });

            if (this.orderDetail.tableData.length === 0) {
                this.chooseProductUuid = true;
            }
            this.updateOrderSort();
        },
        /**
         * 添加新产品行
         */
        addNewProductRow() {
            // 验证必填字段
            if (!this.preSaleOrderRecordVO.selectedWeek) {
                this.$Message.info("请先选择周次！");
                return;
            }

            if (!this.preSaleOrderRecordVO.selectDay) {
                this.$Message.info("请先选择发货日期！");
                return;
            }

            this.chooseProductUuid = false;

            // 给table添加一行空数据（包含唯一 _rowId）
            this.orderDetail.tableData.push({
                _rowId: Date.now() + Math.random(),
                productCodeAndName: "",
                seedFarmName: "",
                productForm: "",
                brandName: "",
                preSalePlanOfferAmount: 0,
                preSalePlanPrice: 0,
                orderQuantity: 0,
                totalMoney: 0,
                productMinOrderAmount: 1,
                productIncreaseStepAmount: 1,
                filterProductList: [...this.orderDetail.productList],
                orderSort: this.orderDetail.tableData.length + 1
            });

            // 初始化新行的可选列表（移除已被其他行选中的商品）
            this.removeSelectedProducts(this.orderDetail.tableData.length - 1);
            this.updateOrderSort();
        },
        /**
         * 将日期对象转换为YYYY-MM-DD格式的字符串
         * @param {Date} date - 日期对象
         * @returns {string} 格式化的日期字符串
         */
        getDateString(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

        /**
         * 将YYYY-MM-DD格式的字符串转换为日期对象
         * @param {string} strDate - 日期字符串
         * @returns {Date} 日期对象
         */
        stringToDate(strDate) {
            const [year, month, day] = strDate.split("-").map(Number);
            return new Date(year, month - 1, day);
        },
        /**
         * 获取预售计划周次列表
         */
        async getWeekList() {
            this.setLoadingState(true);
            let searchParams = search.getSearchParams({ closeAllConditions: true });

            // 只有当选择了具体苗场时才添加 seedFarmUuid 过滤条件
            if (this.preSaleOrderRecordVO.seedFarmUuid) {
                search.globalAddFilterConditionKey(searchParams, "seedFarmUuid", "eq", this.preSaleOrderRecordVO.seedFarmUuid, true);
            }

            try {
                const res = await getPreSalePlanWeekList(searchParams);

                if (res.code === 0 && res.data) {
                    this.handleWeekListResponse(res.data.weekList);
                }
                else {
                    this.$Message.error(res.message || "获取周次列表失败");
                }
            }
            catch (error) {
                console.error("获取周次列表异常:", error);
                this.$Message.error("获取周次列表失败，请稍后重试");
            }
            finally {
                this.setLoadingState(false);
            }
        },

        handleWeekListResponse(weekList) {
            if (!Array.isArray(weekList) || weekList.length === 0) {
                this.resetWeekRelatedData();
                this.$Message.info("当前苗场没有上传供货数据");
                return;
            }

            this.filterModel.selectedYearWeekList = [...weekList];
            this.filterModel.weekList = [...weekList];

            const firstWeek = weekList[0];
            this.preSaleOrderRecordVO.selectedWeek = firstWeek.weekKnownText;
            this.filterModel.dayList = [];

            this.setDeliveryDays(
                firstWeek.weekBeginDate,
                firstWeek.weekEndDate
            );
            if (firstWeek.weekBeginDate) {
                this.loadProductList(firstWeek.weekKnownText);
            }
        },

        setLoadingState(isLoading) {
            this.loading = isLoading;
        },

        resetWeekRelatedData() {
            this.filterModel.selectedYearWeekList = [];
            this.filterModel.weekList = [];
            this.filterModel.dayList = [];
            this.preSaleOrderRecordVO.selectedWeek = "";
        },

        loadProductList(weekText) {
            if (!weekText) return;
            this.getProductList(weekText);
        },

        /**
         * 周次选择变更处理
         */
        onWeekSelectChange() {
            if (this.preSaleOrderRecordVO.selectedWeek) {
                this.getProductList(this.preSaleOrderRecordVO.selectedWeek);

                const week = this.filterModel.weekList.find(
                    (e) =>
                        e.weekKnownText === this.preSaleOrderRecordVO.selectedWeek
                );

                if (week) {
                    const nowString = this.getDateString(new Date());
                    this.filterModel.dayList = [];

                    const weekBeginDate = week.weekBeginDate;
                    const weekEndDate = week.weekEndDate;

                    this.setDeliveryDays(weekBeginDate, weekEndDate);
                }
            }
        },
        onProductSelectChange(row, index) {
            // 获取对应产品的预售计划
            this.fetchPreSaleProductInfo(row.productUuid, index);
        },

        /**
         * 获取预售产品信息
         * @param {string} productUuid - 产品UUID
         * @param {number} index - 表格行索引
         */
        async fetchPreSaleProductInfo(productUuid, index) {
            try {
                const res = await getPreSaleProductInfo({
                    productUuid: productUuid,
                    weekKnownText: this.preSaleOrderRecordVO.selectedWeek
                });

                if (res.code === 0) {
                    if (res.data.preSaleProductInfo != null) {
                        // 更新表格行数据
                        this.updateTableRowData(
                            index,
                            res.data.preSaleProductInfo
                        );
                    }
                    else {
                        this.$Message.info(
                            "当前没有满足条件的供货计划，请上传销售计划！"
                        );
                    }
                }
            }
            catch (error) {
                console.error("获取预售产品信息失败:", error);
                this.$Message.error("获取产品信息失败，请稍后重试！");
            }
        },

        /**
         * 更新表格行数据
         * @param {number} index - 表格行索引
         * @param {Object} productInfo - 产品信息
         */
        updateTableRowData(index, productInfo) {
            const row = this.orderDetail.tableData[index];

            // 基本信息
            row.productUuid = productInfo.productUuid;
            row.preSalePlanUuid = productInfo.preSalePlanUuid;
            row.seedFarmName = productInfo.seedFarmName;
            row.productForm = productInfo.productForm;
            row.brandName = productInfo.brandName;
            row.preSalePlanOfferAmount = productInfo.preSalePlanOfferAmount;
            row.preSalePlanPrice = productInfo.preSalePlanPrice;
            row.productMinOrderAmount = productInfo.productMinOrderAmount;
            row.productIncreaseStepAmount 
                = productInfo.productIncreaseStepAmount;
            row.isRounded = productInfo.isRounded;
            row.unitName = productInfo.unitName;

            // 设置订购数量（最小订购量或可售量）
            row.orderQuantity 
                = productInfo.preSalePlanOfferAmount 
                < productInfo.productMinOrderAmount
                    ? productInfo.preSalePlanOfferAmount
                    : productInfo.productMinOrderAmount;

            // 计算金额
            row.totalMoney = this.calculateItemTotal(
                row.orderQuantity,
                productInfo.preSalePlanPrice
            );
        },
        addToPreSaleCart() {
            // 验证表单
            const validationError = this.validateForm();
            if (validationError) {
                this.$Message.error(validationError);
                return;
            }
            this.updateOrderSort();

            // 构造提交数据
            const preSaleOrderRecordVOArray = this.buildSubmitData();

            // 提交数据
            this.submitOrder(preSaleOrderRecordVOArray);
        },

        /**
         * 验证表单数据
         * @returns {string|null} 错误信息，如果没有错误则返回null
         */
        validateForm() {
            // 基本信息验证
            if (!this.userUuid) {
                return ERROR_MESSAGES.EMPTY_CUSTOMER;
            }

            if (this.orderDetail.tableData.length === 0) {
                return ERROR_MESSAGES.EMPTY_PRODUCT_INFO;
            }

            if (!this.preSaleOrderRecordVO.selectedWeek) {
                return ERROR_MESSAGES.EMPTY_WEEK;
            }

            if (
                !this.preSaleOrderRecordVO.selectDay 
                || this.preSaleOrderRecordVO.selectDay === "1/1/0001 12:00:00 AM"
            ) {
                return ERROR_MESSAGES.EMPTY_DELIVERY_DATE;
            }

            if (!this.preSaleOrderRecordVO.contactNumber) {
                return ERROR_MESSAGES.EMPTY_CONTACT;
            }

            if (!this.preSaleOrderRecordVO.receiptFullAddress) {
                return ERROR_MESSAGES.EMPTY_ADDRESS;
            }

            // 长度验证
            if (this.preSaleOrderRecordVO.contactNumber.length > 100) {
                return ERROR_MESSAGES.CONTACT_TOO_LONG;
            }

            if (this.preSaleOrderRecordVO.receiptFullAddress.length > 500) {
                return ERROR_MESSAGES.ADDRESS_TOO_LONG;
            }

            if (
                this.preSaleOrderRecordVO.remark 
                && this.preSaleOrderRecordVO.remark.length > 500
            ) {
                return ERROR_MESSAGES.REMARK_TOO_LONG;
            }

            // 产品信息验证
            for (const item of this.orderDetail.tableData) {
                if (!item.productUuid) {
                    return ERROR_MESSAGES.EMPTY_PRODUCT_CODE;
                }

                if (
                    item.orderQuantity === "" || item.orderQuantity === undefined
                ) {
                    return ERROR_MESSAGES.EMPTY_QUANTITY;
                }

                if (item.orderQuantity <= 0) {
                    return ERROR_MESSAGES.INVALID_QUANTITY;
                }

                if (!item.preSalePlanUuid) {
                    return ERROR_MESSAGES.EMPTY_PLAN_UUID;
                }
            }

            return null;
        },

        /**
         * 构造提交数据
         * @returns {Array} 提交数据数组
         */
        buildSubmitData() {
            return this.orderDetail.tableData.map((item, index) => ({
                realUserUuid: this.userUuid,
                sendProductDate: this.preSaleOrderRecordVO.selectDay,
                orderQuantity: item.orderQuantity,
                productMinOrderAmount: item.productMinOrderAmount,
                preSalePlanUuid: item.preSalePlanUuid,
                remark: this.preSaleOrderRecordVO.remark,
                submitSource: "Manager",
                orderSort: item.orderSort || index + 1
            }));
        },

        /**
         * 提交订单数据
         * @param {Array} data - 提交的数据
         */
        async submitOrder(data) {
            this.innerSpin = true;
            try {
                const res = await webSubmitToOrderBatch({
                    preSaleOrderRecordVO: data
                });

                if (res.code === 0) {
                    const sortRes = await this.saveOrderSort(data);
                    if (sortRes.code === 0) {
                        this.refreshOrderDetailCache();
                        this.$parent.getUserOrderInfo();
                        this.$Message.success("添加定单成功！");
                        this.show = false;
                    }
                    else {
                        this.$Message.error(
                            sortRes.message || "商品顺序保存失败"
                        );
                    }
                }
                else {
                    this.$Message.error(res.message || "添加定单失败");
                }
            }
            finally {
                this.innerSpin = false;
            }
        },
        async saveOrderSort(data) {
            try {
                const res = await savePreSaleOrderDetailSort({
                    orderSortList: data.map((item, index) => ({
                        realUserUuid: item.realUserUuid,
                        sendProductDate: item.sendProductDate,
                        preSalePlanUuid: item.preSalePlanUuid,
                        orderSort: item.orderSort || index + 1
                    }))
                });
                return res;
            }
            catch (error) {
                return {
                    code: -1,
                    message: "商品顺序保存失败"
                };
            }
        },
        refreshOrderDetailCache() {
            this.orderDetailCache = this.orderDetail.tableData.map(item => ({
                ...item
            }));
        },
        cancel() {
            this.$Message.info("请再次确认信息");
        },
        formatDateTimeString,
        /**
         * 显示模态框
         * @param {string} userUuid - 用户UUID
         * @param {string} defaultSeedFarmUuid - 默认苗场UUID
         */
        async showModal(userUuid, defaultSeedFarmUuid) {
            // 初始化数据
            this.initializeData();

            // 获取基础数据（等待异步完成）
            await this.getSeedFarmList();
            // 设置用户信息
            this.userUuid = userUuid;
            await this.init();

            // 设置默认值（在苗场列表加载完成后再设置）
            // 确保defaultSeedFarmUuid不为undefined
            if (defaultSeedFarmUuid) {
                this.preSaleOrderRecordVO.seedFarmUuid = defaultSeedFarmUuid;
            }
            else {
                // 如果没有提供默认值，选择第一个苗场
                if (this.seedFarmList && this.seedFarmList.length > 0) {
                    this.preSaleOrderRecordVO.seedFarmUuid = this.seedFarmList[0].seedFarmUuid;
                }
            }

            // 获取周次列表
            await this.getWeekList();


            // 使用 nextTick 确保 DOM 更新完成后再显示模态框
            this.$nextTick(() => {
                this.show = true;
            });
        },

        /**
         * 初始化数据
         */
        initializeData() {
            // 重置筛选模型
            this.filterModel.selectedYearWeekList = [];
            this.filterModel.weekList = [];
            this.filterModel.dayList = [];

            // 重置订单详情
            this.orderDetail.tableData = [];

            // 重置预售订单记录
            this.preSaleOrderRecordVO = {
                seedFarmUuid: "",
                selectedWeek: "",
                selectDay: "",
                remark: ""
            };
                        
            // 重置状态
            this.chooseProductUuid = true;

            // 设置年份列表
            this.filterModel.yearList = [
                new Date().getFullYear(),
                new Date().getFullYear() + 1,
                new Date().getFullYear() + 2,
                new Date().getFullYear() + 3,
                new Date().getFullYear() + 4
            ];
        },
        /**
         * 初始化用户信息
         */
        async init() {
            if (this.userUuid) {
                this.innerSpin = true;

                try {
                    const res = await getUserInfoByUuid({
                        userUuid: this.userUuid
                    });

                    if (res.code === 0) {
                        this.preSaleOrderRecordVO = res.data.userInfoVO;
                    }
                }
                catch (error) {
                    console.error("获取用户信息失败:", error);
                }
                finally {
                    this.innerSpin = false;
                }
            }
        },
        /**
         * 获取苗场列表
         */
        async getSeedFarmList() {
            try {
                const searchParams = search.getSearchParams({
                    closeAllConditions: true
                });
                const res = await getSeedFarmAllList(searchParams);

                if (res.code === 0) {
                    // 在苗场列表最前面添加"全部苗场"选项
                    this.seedFarmList = [
                        {
                            seedFarmUuid: "",
                            seedFarmCode: "ALL",
                            seedFarmName: "全部苗场"
                        },
                        ...res.data.records
                    ];
                }
            }
            catch (error) {
                console.error("获取苗场列表失败:", error);
                this.$Message.error("获取苗场列表失败，请稍后重试");
            }
        },

        /**
         * 处理产品选择下拉框开启/关闭事件
         * @param {boolean} status - 下拉框状态
         * @param {number} index - 表格行索引
         */
        handleOpenChange(status, index) {
            if (status) {
                // 使用 $set 确保响应式赋值，避免引用共享问题
                this.$set(this.orderDetail.tableData[index], 'filterProductList', [
                    ...this.orderDetail.productList
                ]);

                // 移除已选择的产品
                this.removeSelectedProducts(index);
            }
        },

        /**
         * 移除已选择的产品（不直接 splice 原数组，生成新数组并赋值）
         * @param {number} currentIndex - 当前行索引
         */
        removeSelectedProducts(currentIndex) {
            const currentRow = this.orderDetail.tableData[currentIndex];
            if (!currentRow) return;

            // 收集除当前行以外已选择的 productUuid
            const selectedSet = new Set();
            this.orderDetail.tableData.forEach((row, i) => {
                if (i !== currentIndex && row.productUuid) {
                    selectedSet.add(row.productUuid);
                }
            });

            // 生成新的可选列表（过滤掉已被其他行选择的产品）
            const newList = this.orderDetail.productList.filter(
                (item) => !selectedSet.has(item.productUuid)
            );

            // 使用 $set 替换，确保响应式更新并避免原数组被污染
            this.$set(currentRow, 'filterProductList', newList);
        },
        getSeedFarmDeliveryWeek() {
            if (this.$checkAccessArray(["P", "B", "C"]) === true) {
                getSeedFarmDeliveryWeek().then((res) => {
                    if (res.code === 0) {
                        this.seedFarmDeliveryWeek = res.data;
                        // 记录苗场配送日信息
                        // console.log("苗场配送日：", this.seedFarmDeliveryWeek);
                    }
                });
            }
        },
        /**
         * 设置配送日期范围
         * @param {string} weekBeginDate 周开始日期 (格式: YYYY-MM-DD)
         * @param {string} weekEndDate 周结束日期 (格式: YYYY-MM-DD)
         */
        setDeliveryDays(weekBeginDate, weekEndDate) {
            // 1. 验证日期参数的有效性
            if (!this.validateDateRange(weekBeginDate, weekEndDate)) {
                this.resetDeliveryDays();
                return;
            }

            // 2. 准备日期对象和当前日期字符串
            const startDate = new Date(weekBeginDate);
            const endDate = new Date(weekEndDate);
            const currentDateStr = this.getDateString(new Date());

            // 3. 生成可用的配送日期列表（从当前日期开始的未来日期）
            this.filterModel.dayList = this.generateAvailableDayList(
                startDate,
                endDate,
                currentDateStr
            );

            // 4. 设置默认选中的配送日期
            this.setDefaultDeliveryDay(
                weekBeginDate,
                weekEndDate,
                currentDateStr
            );
        },

        /**
         * 验证日期范围的有效性
         * @param {string} weekBeginDate 周开始日期
         * @param {string} weekEndDate 周结束日期
         * @returns {boolean} 验证结果
         */
        validateDateRange(weekBeginDate, weekEndDate) {
            // 检查参数是否为空
            if (!weekBeginDate || !weekEndDate) {
                return false;
            }

            try {
                // 尝试创建日期对象
                const startDate = new Date(weekBeginDate);
                const endDate = new Date(weekEndDate);

                // 检查日期是否有效
                if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                    return false;
                }

                // 检查开始日期是否不晚于结束日期
                return startDate <= endDate;
            }
            catch (error) {
                console.error("setDeliveryDays: 日期验证失败", error);
                return false;
            }
        },

        /**
         * 生成可用的配送日期列表
         * 只包含当前日期及之后的日期
         * @param {Date} startDate 开始日期
         * @param {Date} endDate 结束日期
         * @param {string} currentDateStr 当前日期字符串
         * @returns {string[]} 可用日期列表
         */
        generateAvailableDayList(startDate, endDate, currentDateStr) {
            const dayList = [];

            // 计算总天数，避免在循环中修改Date对象
            const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

            // 遍历每一天，生成日期列表
            for (let i = 0; i < totalDays; i++) {
                // 创建新的日期对象，避免引用问题
                const currentDate = new Date(startDate);
                currentDate.setDate(startDate.getDate() + i);

                const dayString = this.getDateString(currentDate);

                // 只添加当前日期及之后的日期
                if (dayString >= currentDateStr) {
                    dayList.push(dayString);
                }
            }

            return dayList;
        },

        /**
         * 设置默认配送日期
         * 优先选择当前日期，其次选择周开始日期
         * @param {string} weekBeginDate 周开始日期
         * @param {string} weekEndDate 周结束日期
         * @param {string} currentDateStr 当前日期字符串
         */
        setDefaultDeliveryDay(weekBeginDate, weekEndDate, currentDateStr) {
            // 判断当前日期是否在周范围内
            const hasCurrentDate = weekBeginDate <= currentDateStr && currentDateStr <= weekEndDate;

            // 设置默认选中的配送日期
            if (hasCurrentDate) {
                // 如果当前日期在周范围内，优先选择当前日期
                this.preSaleOrderRecordVO.selectDay = currentDateStr;
            }
            else {
                // 否则选择周开始日期
                this.preSaleOrderRecordVO.selectDay = weekBeginDate;
            }

            // 检查是否需要更新为苗场配送日
            this.updateDeliveryDayForSeedFarm();
        },

        /**
         * 根据苗场配送日更新选中的配送日期
         * 如果存在匹配的苗场配送日，则优先选择
         */
        updateDeliveryDayForSeedFarm() {
            // 检查是否有苗场配送日配置和可用日期列表
            if (
                !this.seedFarmDeliveryWeek || !this.filterModel.dayList.length
            ) {
                return;
            }

            // 在可用日期列表中查找匹配的苗场配送日
            const matchingDay = this.filterModel.dayList.find((dayStr) => {
                const date = new Date(dayStr);
                return date.getDay() === this.seedFarmDeliveryWeek;
            });

            // 如果找到匹配的日期，则更新选中的配送日期
            if (matchingDay) {
                this.preSaleOrderRecordVO.selectDay = matchingDay;
            }
        },

        /**
         * 重置配送相关数据
         * 清空日期列表和选中的配送日期
         */
        resetDeliveryDays() {
            this.filterModel.dayList = [];
            this.preSaleOrderRecordVO.selectDay = "";
        }
    }
};
</script>

<style>
.red-color {
    color: red;
    font-weight: bold;
}
.add-wrap .ivu-modal-body {
    padding: 0px 16px;
}
.add-wrap .ivu-table-cell {
    text-align: center;
}
.add-wrap .ivu-table-small th {
    text-align: center;
}
.add-wrap .ivu-table {
    padding-bottom: 160px;
}
.add-wrap .ivu-table th,
.ivu-table td {
    text-align: center !important;
}
.add-wrap th.ivu-table-column-left,
td.ivu-table-column-left {
    text-align: center !important;
}
.add-wrap th.ivu-table-column-right,
td.ivu-table-column-right {
    text-align: center !important;
}
.add-wrap .ivu-select-dropdown {
    max-height: 160px;
}

.customerColor .ivu-input {
    color: #000;
    font-weight: bold;
}
</style>
